import { cityPickerValidator } from "@/validator/validator";
export const registerSteps = [
  {
    title: "新建账户",
    icon: "md-person",
    component: "confirm-account"
  },
  {
    title: "设置密码",
    icon: "md-lock",
    component: "set-password"
  },
  {
    title: "创建团队",
    icon: "ios-create",
    component: "create-enterprise"
  }
];

export const initCreateEnterpriseForm = {
  enterpriseName: "",
  enterpriseCode: "",
  local: "",
  type: "",
  scaleItemId: "",
  selectedCity: {
    provinceId: "",
    cityId: "",
    areaId: ""
  }
};

export const createEnterpriseFormRules = {
  enterpriseName: [
    {
      required: true,
      message: "请填写团队名称！",
      trigger: "blur"
    }
  ],
  enterpriseCode: [
    {
      required: true,
      message: "请填写团队编码！",
      trigger: "blur"
    }
  ],
  local: [
    {
      required: true,
      message: "请选择所在地！",
      trigger: "blur",
      min: 8
    }
  ],
  type: [
    {
      required: true,
      message: "请选择所属行业！",
      trigger: "blur"
    }
  ],
  scaleItemId: [
    {
      required: true,
      message: "请选择人员规模！",
      trigger: "blur"
    }
  ],
  selectedCity: cityPickerValidator
};

export const industryTypes = [
  {
    value: "通信",
    label: "IT|通信|电子|互联网",
    children: [
      {
        value: "计算机软件",
        label: "计算机软件"
      },
      {
        value: "网络游戏",
        label: "网络游戏"
      },
      {
        value: "IT服务(系统/数据/维护)",
        label: "IT服务(系统/数据/维护)"
      },
      {
        value: "计算机硬件",
        label: "计算机硬件"
      },
      {
        value: "互联网/电子商务",
        label: "互联网/电子商务"
      },
      {
        value: "电子技术/半导体/集成电路",
        label: "电子技术/半导体/集成电路"
      },
      {
        value: "通信/电信运营、增值服务",
        label: "通信/电信运营、增值服务"
      },
      {
        value: "通信/电信/网络设备",
        label: "通信/电信/网络设备"
      }
    ]
  },
  {
    value: "金融业",
    label: "金融业",
    children: [
      {
        value: "保险",
        label: "保险"
      },
      {
        value: "银行",
        label: "银行"
      },
      {
        value: "信托/担保/拍卖/典当",
        label: "信托/担保/拍卖/典当"
      },
      {
        value: "基金/证券/期货/投资",
        label: "基金/证券/期货/投资"
      }
    ]
  },
  {
    value: "房地产|建筑业",
    label: "房地产|建筑业",
    children: [
      {
        value: "房地产/建筑/建材/工程",
        label: "房地产/建筑/建材/工程"
      },
      {
        value: "物业管理/商业中心",
        label: "物业管理/商业中心"
      },
      {
        value: "家居/室内设计/装饰装潢",
        label: "家居/室内设计/装饰装潢"
      }
    ]
  },
  {
    value: "商业服务",
    label: "商业服务",
    children: [
      {
        value: "专业服务/咨询",
        label: "专业服务/咨询"
      },
      {
        value: "广告/会展/公关",
        label: "广告/会展/公关"
      },
      {
        value: "nanjing",
        label: "中介服务"
      },
      {
        value: "外包服务",
        label: "外包服务"
      },
      {
        value: "检验/检测/认证",
        label: "检验/检测/认证"
      }
    ]
  },
  {
    value: "贸易|批发|零售|租赁业",
    label: "贸易|批发|零售|租赁业",
    children: [
      {
        value: "零售/批发",
        label: "零售/批发"
      },
      {
        value: "贸易/进出口",
        label: "贸易/进出口"
      },
      {
        value: "快速消费品",
        label: "快速消费品"
      },
      {
        value: "耐用消费品",
        label: "耐用消费品"
      }
    ]
  },
  {
    value: "文体教育|工艺美术",
    label: "文体教育|工艺美术",
    children: [
      {
        value: "教育/培训/院校",
        label: "教育/培训/院校"
      },
      {
        value: "礼品/玩具/工艺美术/收藏品/奢侈品",
        label: "礼品/玩具/工艺美术/收藏品/奢侈品"
      }
    ]
  },
  {
    value: "服务业",
    label: "服务业",
    children: [
      {
        value: "酒店/餐饮",
        label: "酒店/餐饮"
      },
      {
        value: "旅游/度假",
        label: "旅游/度假"
      },
      {
        value: "医疗/护理/美容/保健/卫生服务",
        label: "医疗/护理/美容/保健/卫生服务"
      }
    ]
  },
  {
    value: "文化|传媒|娱乐|体育",
    label: "文化|传媒|娱乐|体育",
    children: [
      {
        value: "娱乐/体育/休闲",
        label: "娱乐/体育/休闲"
      },
      {
        value: "媒体/出版/影视/文化传播",
        label: "媒体/出版/影视/文化传播"
      }
    ]
  },
  {
    value: "生产|加工|制造",
    label: "生产|加工|制造",
    children: [
      {
        value: "办公用品及设备",
        label: "办公用品及设备"
      },
      {
        value: "航空/航天研究与制造",
        label: "航空/航天研究与制造"
      },
      {
        value: "医疗设备/器械",
        label: "医疗设备/器械"
      },
      {
        value: "加工制造（原料加工/模具）",
        label: "加工制造（原料加工/模具）"
      },
      {
        value: "大型设备/机电设备/重工业",
        label: "大型设备/机电设备/重工业"
      },
      {
        value: "印刷/包装/造纸",
        label: "印刷/包装/造纸"
      },
      {
        value: "汽车/摩托车",
        label: "汽车/摩托车"
      },
      {
        value: "仪器仪表及工业自动化",
        label: "仪器仪表及工业自动化"
      }
    ]
  },
  {
    value: "交通|运输|物流|仓储",
    label: "交通|运输|物流|仓储",
    children: [
      {
        value: "交通/运输",
        label: "交通/运输"
      },
      {
        value: "物流/仓储",
        label: "物流/仓储"
      }
    ]
  },
  {
    value: "能源|矿产|环保",
    label: "能源|矿产|环保",
    children: [
      {
        value: "环保",
        label: "环保"
      },
      {
        value: "石油/石化/化工",
        label: "石油/石化/化工"
      },
      {
        value: "能源/矿产/采掘/冶炼",
        label: "能源/矿产/采掘/冶炼"
      },
      {
        value: "电气/电力/水利",
        label: "电气/电力/水利"
      }
    ]
  },
  {
    value: "政府|非盈利机构",
    label: "政府|非盈利机构",
    children: [
      {
        value: "学术/科研",
        label: "学术/科研"
      },
      {
        value: "政府/公共事业/非盈利机构",
        label: "政府/公共事业/非盈利机构"
      }
    ]
  },
  {
    value: "农|林|牧|渔|其他",
    label: "农|林|牧|渔|其他",
    children: [
      {
        value: "跨领域经营",
        label: "跨领域经营"
      },
      {
        value: "农/林/牧/渔",
        label: "农/林/牧/渔"
      },
      {
        value: "其他",
        label: "其他"
      }
    ]
  }
];
